import Vue from 'vue'
import Vuex from 'vuex'

import user from './user'
import contacts from './contacts'
import groops from './groops'
import events from './events'
import members from './members'
import conversations from './conversations'
import files from './files'
import news from './news'
import publicPage from './publicPage'
import polls from './polls'
import search from './search'
import toAnswer from './toAnswer'
import sharedObjects from './sharedObjects'
import chat from './chat'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    contacts,
    groops,
    events,
    members,
    conversations,
    files,
    news,
    sharedObjects,
    publicPage,
    polls,
    search,
    toAnswer,
    chat,
    store: {
      actions: {
        storeClean (ctx) {
          ctx.dispatch('news/clean')
          ctx.dispatch('toAnswer/clean')
          ctx.dispatch('chat/clean')
          ctx.dispatch('contacts/clean')
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js